module.exports = __webpack_public_path__ + "img/apple-1.26985c6.png";